export const UPDATE_EXPIRY_MODAL_FORM_KEYS = {
  expiry_date: "expiry_date",
  start_date: "start_date",
};
